import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// When any AI call is rejected for lack of credits, broadcast so the Buy Credits sheet can open.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 402 && d && d.code === "insufficient_credits") {
      window.dispatchEvent(new CustomEvent("fv:need-credits", { detail: d }));
    }
    return Promise.reject(err);
  }
);

export function fileUrl(path) {
  if (!path) return null;
  const token = localStorage.getItem("fv_token");
  return `${API}/files/${path}?auth=${token}`;
}

// Real first-frame poster for a stored video (generated server-side via ffmpeg, cached).
export function posterUrl(path) {
  if (!path) return null;
  const token = localStorage.getItem("fv_token");
  return `${API}/video-poster/${path}?auth=${token}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
